import { compareAccDocKey } from "../../decorators/StoreIdEquality";
import { stringifyKey } from "../../decorators/StoreIdHelper";
import { StoreName } from "../../decorators/StoreNameDecorator";
import AcceleratorDoc, {
  AcceleratorDocStoreKey,
} from "../../models/AcceleratorDoc";
import { AcceleratorDocMetadata } from "../../models/AcceleratorDocMetadata";
import { AbstractRemovableStore } from "../RemovableStore";

@StoreName("AcceleratorDocMetadataStore")
class AcceleratorDocMetadataStoreClass extends AbstractRemovableStore<
  AcceleratorDocStoreKey,
  AcceleratorDocMetadata
> {
  storedObjectKeysEquals(
    a: AcceleratorDocStoreKey,
    b: AcceleratorDocStoreKey,
  ): boolean {
    return compareAccDocKey(a, b);
  }

  async lookup(
    compositeKey: AcceleratorDocStoreKey,
  ): Promise<AcceleratorDocMetadata | undefined> {
    throw new Error("Method not implemented.");
  }

  getAll(): Array<AcceleratorDocMetadata> {
    const returnValues = this.values;
    // SweetListSorter.sort(returnValues, (data) => data.batchInstanceId, 'DOC', 10);
    return returnValues;
  }

  getByBatchInstanceUuid(
    batchInstanceUuid: string,
  ): Array<AcceleratorDocMetadata> {
    return this.values.filter(
      (x) => x.storeId.batchInstanceUuid === batchInstanceUuid,
    );
  }

  markAllDocMetadataStale(
    batchInstanceUuid: string,
    stale: boolean = true,
  ): void {
    this.getByBatchInstanceUuid(batchInstanceUuid)?.forEach((metadata) => {
      console.debug(
        `Marking ${stringifyKey(metadata.storeId)} as stale=${stale}`,
      );
      metadata.stale = stale;
      AcceleratorDocMetadataStore.set(metadata);
    });
  }

  markAllDocMetadataErrorLoading(
    batchInstanceUuid: string,
    loadingError: boolean = true,
  ): void {
    this.getByBatchInstanceUuid(batchInstanceUuid)?.forEach((metadata) => {
      console.debug(
        `Marking ${stringifyKey(metadata.storeId)} as loadingError=${loadingError}`,
      );
      metadata.loadingError = loadingError;
      AcceleratorDocMetadataStore.set(metadata);
    });
  }

  // performance optimized getWithoutLookup
  public getWithoutLookup(id: AcceleratorDocStoreKey) {
    return this.values.filter((x) => compareAccDocKey(x.storeId, id))[0];
  }

  //@ts-expect-error
  _vamp(values) {
    //@ts-expect-error
    this.values = values.map((r) => new AcceleratorDocMetadata(r));
  }
  _unvamp() {
    return this.values;
  }
}

const AcceleratorDocMetadataStore = new AcceleratorDocMetadataStoreClass();
export { AcceleratorDocMetadataStore, AcceleratorDocMetadataStoreClass };
